"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReservationV1Serializer = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
function getReservationV1Serializer() {
    return (0, serializers_1.struct)([
        ['address', (0, serializers_1.publicKey)()],
        ['spotsRemaining', (0, serializers_1.u8)()],
        ['totalSpots', (0, serializers_1.u8)()],
    ], { description: 'ReservationV1' });
}
exports.getReservationV1Serializer = getReservationV1Serializer;
//# sourceMappingURL=reservationV1.js.map